/* =============================================================================
   "AVISA-ME QUANDO VOLTAR" — o comportamento, num sítio só.

   ⚠️ ESTE FICHEIRO É O ÚNICO DONO desta caixa. A marcação está em
   `snippets/ilha-avisa-me.liquid` e os dois modelos de página usam ambos:
     · a ITP  (`templates/product.ilha.liquid`)      — 657 produtos
     · o antigo (`snippets/buy-buttons.liquid`)      — 2 753 produtos
   Antes disto a caixa só existia dentro da ITP, e nos outros 2 753 quem punha o
   botão E o formulário era o Klaviyo. Silva, 4/09/2026: *"o que é nosso é só
   aquele botão."* Tinha razão.

   ⛔ NÃO DUPLICAR ISTO. Se um dia parecer mais fácil copiar a caixa para outro
   modelo, é sinal de que se deve chamar o snippet a partir de lá.
   ========================================================================== */
(function () {
  'use strict';
  if (window.IlhaAvisaMe) return;                 // já ligado nesta página

  var PORTA = 'https://contas.ilhadoscosmeticos.pt/reposicao/avisar-me';
  var KLAVIYO = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=RmV7Zd';

  var caixa, abrirBt, painel, enviarBt, campo, aviso, linhaInput, intro,
      opcao, marca, textoConsent, pequena, dados = null, actual = null, rotulo = 'Avisa-me';

  function $(id) { return document.getElementById(id); }

  function apanhar() {
    caixa = $('itpBis'); abrirBt = $('itpBisOpen'); painel = $('itpBisPanel');
    enviarBt = $('itpBisSend'); campo = $('itpBisEmail'); aviso = $('itpBisMsg');
    linhaInput = $('itpBisInputRow'); intro = $('itpBisLead'); opcao = $('itpBisOptRow');
    marca = $('itpBisNovidades'); textoConsent = $('itpBisConsentimento'); pequena = $('itpBisFine');
    return !!(caixa && abrirBt && enviarBt && campo);
  }

  function dizer(txt, bem) {
    if (!aviso) return;
    aviso.textContent = txt; aviso.hidden = false;
    aviso.className = 'bis-msg ' + (bem ? 'ok' : 'err');
  }

  function abrir() {
    if (painel) painel.hidden = false;
    if (abrirBt) abrirBt.hidden = true;
    if (campo) campo.focus();
  }

  /* Repõe a caixa ao estado inicial. ⚠️ Inclui a linha do consentimento e a letra
     pequena: o envio com sucesso esconde-as, e sem as repor, mudar de tom depois
     de um pedido deixava a pessoa sem poder dizer que sim ao tom seguinte. */
  function repor() {
    if (abrirBt) abrirBt.hidden = false;
    if (painel) painel.hidden = true;
    if (linhaInput) linhaInput.hidden = false;
    if (intro) intro.hidden = false;
    if (opcao) opcao.hidden = false;
    if (pequena) pequena.hidden = false;
    if (aviso) aviso.hidden = true;
    if (enviarBt) { enviarBt.disabled = false; enviarBt.textContent = rotulo; }
  }

  function feito() {
    /* ⚠️ Mostra-se sempre o mesmo, mesmo quando ela já tinha pedido este produto
       (`ja_pedido`). Dizer-lhe "já tinhas pedido" não lhe serve de nada. */
    if (linhaInput) linhaInput.hidden = true;
    if (intro) intro.hidden = true;
    if (opcao) opcao.hidden = true;
    if (pequena) pequena.hidden = true;
    dizer('✓ Prontinho! Avisamos-te por email assim que este produto voltar.', true);
  }

  function falhou() {
    if (enviarBt) { enviarBt.disabled = false; enviarBt.textContent = rotulo; }
    dizer('Não foi possível registar agora. Tenta daqui a pouco, ou fala connosco pelo chat.', false);
  }

  /* ---------- A PONTE, e é para durar pouco ----------
     ⚠️⚠️ Enquanto os 2 753 produtos do modelo antigo não tiverem esta caixa, o
     widget do Klaviyo tem de continuar ligado — e enquanto ele estiver ligado,
     esta ponte garante que nenhum pedido se perde se a nossa porta falhar.
     ⛔ SÓ SE APAGA quando a Nortada confirmar que recebe tudo e o widget do
     Klaviyo sair. Ver `nortada/RESPOSTA-DO-TEMA.md`. */
  function pelaAntiga(mail, v) {
    fetch(KLAVIYO, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: { profile: { data: { type: 'profile', attributes: { email: mail } } }, channels: ['EMAIL'] },
          relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + v.id } } }
        }
      })
    }).then(function (r) { if (r.status === 202 || r.ok) { feito(); } else { falhou(); } })
      .catch(falhou);
  }

  function enviar() {
    var mail = (campo.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(mail)) { dizer('Escreve um email válido, por favor.', false); campo.focus(); return; }
    var v = actual;
    if (!v || !v.id) { dizer('Não foi possível identificar o produto. Recarrega a página.', false); return; }
    /* ⚠️ O SKU é da VARIANTE. Sem ele a Nortada recusa com `sem_sku` — e numa
       coloração de 94 tons, o SKU do produto avisava a pessoa do tom errado. */
    if (!v.sku) { dizer('Este produto não pode ser avisado por agora. Fala connosco pelo chat.', false); return; }

    enviarBt.disabled = true; enviarBt.textContent = 'A enviar…';
    fetch(PORTA, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: mail,
        sku: v.sku,
        produtoId: String(dados.produtoId),
        varianteId: String(v.id),
        nomeProduto: dados.produtoNome + (v.t && v.t !== 'Default Title' ? ' ' + v.t : ''),
        preco: ((v.p || 0) / 100).toFixed(2),
        origem: 'pagina-de-produto',
        quereNovidades: !!(marca && marca.checked),
        /* ⚠️ A prova sai do ECRÃ, não do código: é a frase que ela mesma leu.
           Assim as duas não se podem separar, em vez de "não se devem". */
        textoConsentimento: textoConsent ? (textoConsent.textContent || '').trim() : ''
      })
    }).then(function (r) {
      if (r.status === 201 || r.status === 200) { feito(); return; }
      if (r.status === 429) { enviarBt.disabled = false; enviarBt.textContent = rotulo;
        dizer('Já registámos há pouco. Espera um bocadinho e tenta outra vez.', false); return; }
      pelaAntiga(mail, v);
    }).catch(function () { pelaAntiga(mail, v); });
  }

  /* Diz à caixa qual é a variante escolhida. Chamada pela ITP quando o tom muda,
     e pelo próprio ficheiro quando é o modelo antigo a mandar. */
  function definirVariante(id) {
    if (!dados) return;
    var achou = null;
    for (var i = 0; i < dados.variantes.length; i++) {
      if (String(dados.variantes[i].id) === String(id)) { achou = dados.variantes[i]; break; }
    }
    if (!achou) return;
    var mudou = !actual || String(actual.id) !== String(achou.id);
    actual = achou;
    if (caixa) caixa.hidden = !!achou.a;          // com stock, a caixa não aparece
    if (mudou && !achou.a) repor();
  }

  function arrancar() {
    /* ⚠️⚠️ A MESMA CAIXA PODE VIR DUAS VEZES NA PÁGINA, e vinha (07/09/2026).
       O `buy_buttons` é um BLOCO do tema e a ficha de produto tem DOIS configurados,
       por isso o snippet é desenhado duas vezes. Resultado: dois botões "Avisa-me"
       iguais, ids repetidos, e o segundo morto — o `getElementById` só devolve o
       primeiro, logo o outro ficava a não fazer nada quando lhe tocassem.
       ⚠️ Não se resolve na configuração do tema: o segundo bloco pode ser de
       propósito e amanhã há um terceiro. Resolve-se aqui, e fica resolvido. */
    var repetidas = document.querySelectorAll('#itpBis');
    for (var i = 1; i < repetidas.length; i++) repetidas[i].remove();
    var dados2 = document.querySelectorAll('#itpBisDados');
    for (var j = 1; j < dados2.length; j++) dados2[j].remove();

    if (!apanhar()) return;
    var bruto = $('itpBisDados');
    if (!bruto) return;
    try { dados = JSON.parse(bruto.textContent); } catch (e) { return; }
    if (!dados || !dados.variantes || !dados.variantes.length) return;

    /* ⚠️ O rótulo do botão lê-se do PRÓPRIO BOTÃO, uma vez. Já esteve escrito em
       três sítios e um deles repunha a versão antiga por cima da nova. */
    rotulo = (enviarBt.textContent || 'Avisa-me').trim();

    abrirBt.addEventListener('click', abrir);
    enviarBt.addEventListener('click', enviar);
    campo.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter') { ev.preventDefault(); enviar(); }
    });

    definirVariante(dados.escolhida);

    /* No modelo antigo quem manda na variante é o `[name="id"]` do formulário do
       carrinho. Na ITP é a própria ITP que chama `definirVariante`. */
    if (!dados.itp) {
      var form = document.querySelector('form[action*="/cart/add"]');
      var campoId = form && form.querySelector('[name="id"]');
      if (form && campoId) {
        form.addEventListener('change', function () { definirVariante(campoId.value); });
        setInterval(function () {
          if (campoId.value && (!actual || String(actual.id) !== String(campoId.value))) definirVariante(campoId.value);
        }, 700);
      }
    }
  }

  window.IlhaAvisaMe = { abrir: abrir, repor: repor, definirVariante: definirVariante };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
